import React from "react";

import commonStyles from "styles/common.module.scss";
import styles from "./articleHeader.module.scss";

interface BreadcrumbProps {
    uri: string;
    title: string;
}

interface ArticleHeaderProps {
    articleTitle: string;
    breadcrumbs: BreadcrumbProps[];
}

const ArticleBreadcrumbLinks = (props: { crumbs: BreadcrumbProps[], articleTitle: string }) => {
    const { crumbs, articleTitle } = props;
    const linkStyle = `${styles.breadCrumbLink} ${commonStyles.callToAction}`;
    const cleanCrumbs = crumbs.filter((x: BreadcrumbProps) => x.title && x.title !== articleTitle);
    const crumbsLength = cleanCrumbs.length - 1;
    return (
        <>
            {cleanCrumbs.map((x: BreadcrumbProps, i: number) => (
                <React.Fragment key={x.title}>
                    <a href={`/${x.uri}`} className={linkStyle}>{x.title}</a>
                    {i < crumbsLength ? <span className={linkStyle}>{" / "}</span> : null }
                </React.Fragment>
            ))}
        </>
    );
};

export const ArticleHeader: React.FC<ArticleHeaderProps> = ({ articleTitle, breadcrumbs }) => {
    const crumbs = breadcrumbs
        .filter((x: BreadcrumbProps) => x.title && x.uri && x.title !== articleTitle)
        .map((x: BreadcrumbProps) => ((/^advice$/i).test(x.uri) ? { title: "Advice", uri: "advice" } : x));

    return (
        <header className={styles.articleHeader}>
            <div className={styles.container}>
                <ArticleBreadcrumbLinks crumbs={crumbs} articleTitle={articleTitle} />
                <h1 className={styles.title}>{articleTitle}</h1>
            </div>
        </header>
    );
};
